















































































import {Component, Mixins, Prop, Ref} from 'vue-property-decorator';
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import anime from "animejs"
import TextProviderMixin from "@/design-system/utilities/TextProviderMixin"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import JdsCloseSymbol from "@/design-system/shared/JdsCloseSymbol.vue"
import { Portal } from '@linusborg/vue-simple-portal'
import { JdsError } from '@/design-system/utilities/JdsError';


/**
 * @status stable
 * @published 3.3.0
 * @changelog 3.3.0 Published.
 * @changelog 4.6.0 Switch to simple-portal.
 * @typed
 */
@Component({
    components: {JdsButton, JdsCloseSymbol, SimplePortal: Portal}
})
export default class JdsConfirmation extends Mixins(TextProviderMixin, UniqueIdMixin) {
    @Ref() popupEl!: HTMLElement;
    @Ref() popupInnerEl!: HTMLElement;
    @Ref() popupButtonsEl!: HTMLElement;
    @Ref() animationEl!: HTMLElement;
    @Ref() backdropEl!: HTMLElement;
    state: boolean = false;

    /**
     * Use this if this confirmation affects a particularly destructive action, such as deletion.
     */
    @Prop({default: false, type: Boolean}) danger!: boolean;

    protected onConfirm?: (a: UIEvent) => any;
    protected onCancel?: (a: UIEvent) => any;
    protected lastResult?: 'confirm' | 'cancel';

    keyListener(e: KeyboardEvent) {
        if (e.key === 'Escape' && !this.popupEl.contains(e.target as Node)) {
            this.cancelCallback(e);
        }
    }

    confirm() {
        document.addEventListener('keyup', this.keyListener);
        this.state = true;

        this.$nextTick(() => {
            // this.$nextTick(() => {
            //     AcquireFirstFocus(this.popupButtonsEl);
            // })
        });

        return new Promise<UIEvent>((res, err) => {
            this.onConfirm = res;
            this.onCancel = () => {
                err(new JdsError('Confirmation cancelled', (this.$options.name as string), 'cancel'));
            };
        });
    }

    confirmCallback(event: UIEvent) {
        this.$emit('confirm', event);
        this.lastResult = 'confirm';
        if (this.onConfirm) this.onConfirm(event);
        this.close();
    }

    cancelCallback(event: UIEvent) {
        this.$emit('cancel', event);
        this.lastResult = 'cancel';
        if (this.onCancel) this.onCancel(event);
        this.close();
    }

    close() {
        document.removeEventListener('keyup', this.keyListener);
        this.state = false;
    }

    enter(el: Node, done: () => void) {
        const h = anime.get(this.popupEl, 'height') as string;
        anime.timeline({
            easing: 'easeInOutExpo',
            complete: done,
        }).add({
            targets: this.popupEl,
            scale: [0.8, 1],
            translateY: [15, 0],
            rotateX: ['25deg', 0],
            easing: 'spring(0.1, 70, 3.5, 0)',
        }).add({
            targets: this.animationEl,
            height: [h, 0],
            duration: 0,
        }, 0).add({
            targets: this.backdropEl,
            opacity: [0, 1],
            duration: 250,
            easing: 'easeOutExpo'
        }, 0)
    }

    leave(el: Node, done: () => void) {
        if (this.lastResult === 'cancel') {
            anime.timeline({
                complete: done,
            }).add({
                targets: this.popupEl,
                opacity: ['100%', '0%'],
                scale: [1, 0.8],
                duration: 200,
                easing: 'easeInCubic',
                complete: done,
            }).add({
                targets: this.backdropEl,
                opacity: [1, 0],
                duration: 200,
                easing: 'linear'
            }, 0)
        } else {
            const h = anime.get(this.popupEl, 'height') as string;
            anime.timeline({
                easing: 'easeInOutExpo',
                complete: done,
            }).add({
                targets: this.animationEl,
                height: [0, h],
                top: [h, 0],
                duration: 300,
            }).add({
                targets: this.popupEl,
                scale: [1, 1.1],
                opacity: [1, 0],
                duration: 350,
                easing: 'easeOutExpo',
            }, '+=70').add({
                targets: this.backdropEl,
                opacity: [1, 0],
                duration: 200,
                easing: 'easeOutExpo'
            }, 0)
        }
    }
}
